"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniPDPTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const MiniPDPTitle = ({ productBrand, productTitle, isProductOutOfStock, }) => ((0, jsx_runtime_1.jsx)(cotopaxi_1.Box, { mobile: { spacing: { marginTop: 2 } }, opacity: isProductOutOfStock && 0.5, children: (0, jsx_runtime_1.jsxs)(cotopaxi_1.Text, { lineClamp: 1, children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.Text, { emphasized: true, inline: true, children: productBrand }), ` ${productTitle}`] }) }));
exports.MiniPDPTitle = MiniPDPTitle;
